import { createApiCallActions } from 'src/app/common/store/generic.actions';
import { Title } from './types';

export const titleActions = {
  getById: createApiCallActions<Title>('title', 'getById'),
  postTitle: createApiCallActions<Title>('title', 'postTitle'),
  updateTitle: createApiCallActions<Title>('title', 'updateTitle'),
};

export type TitleAction = typeof titleActions;
